import _extends from "@babel/runtime/helpers/extends";
/* @jsx jsx */
import { jsx } from '@emotion/react';
import { forwardRef } from 'react';
import { defaultPaddingStyles, getPaddingAdjustments, floatingContainerStyles, prismBorderAnimationStyles, prismBorderStyles } from './styles';
import { useAIThemeColor } from '../../styles/theme';
export const FloatingContainer = /*#__PURE__*/forwardRef(({
  children,
  paddingAdjustments,
  rainbowBorder = true,
  rainbowBorderAnimation,
  disablePadding,
  css,
  ...rest
}, ref) => {
  const paddingStyles = disablePadding ? null : paddingAdjustments ? getPaddingAdjustments(paddingAdjustments) : defaultPaddingStyles;
  const aiThemeColor = useAIThemeColor();
  const cssStyles = [floatingContainerStyles, paddingStyles, css];
  if (rainbowBorder) {
    cssStyles.push(prismBorderStyles(aiThemeColor));
    if (rainbowBorderAnimation) {
      cssStyles.push(prismBorderAnimationStyles);
    }
  }
  return jsx("div", _extends({
    ref: ref,
    css: cssStyles
  }, rest), children);
});